var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesOrder = function SvgSalesOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.75 14.805c0 1.633.805 2.445 2.422 2.445H8.62a5 5 0 0 1-.305-1.258h-5.09c-.804 0-1.218-.43-1.218-1.21V2.976c0-.774.414-1.22 1.226-1.22h3.477v4.54c0 .984.492 1.469 1.469 1.469h4.453v2.762a5 5 0 0 1 1.258-.007V7.71c0-1.008-.118-1.445-.743-2.086L8.844 1.242C8.25.632 7.758.5 6.883.5H3.172C1.562.5.75 1.328.75 2.953zm11.64-8.22H8.32c-.312 0-.43-.124-.43-.437V2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.32 15.484c0-2.171 1.79-3.968 3.97-3.968 2.179 0 3.968 1.797 3.968 3.968a3.984 3.984 0 0 1-3.969 3.97c-2.164 0-3.969-1.813-3.969-3.97m6.47.001c0-.125-.056-.234-.18-.375l-1.602-1.742a.5.5 0 0 0-.367-.172c-.274-.015-.47.203-.47.477-.007.133.071.265.165.36l.469.46.53.516-1-.04h-2.07c-.273 0-.5.235-.5.516s.227.516.5.516h2.07l1-.04-.53.509-.47.469a.6.6 0 0 0-.163.359c-.016.266.195.469.469.469a.46.46 0 0 0 .367-.165l1.601-1.742c.118-.14.18-.242.18-.375",
    clipRule: "evenodd"
  })));
};
export default SvgSalesOrder;